const PROGRAMS = 'PROGRAMS';
const PROGRAMS_FETCH_STARTED = PROGRAMS + '_FETCH_STARTED';
const PROGRAMS_FETCH_COMPLETED = PROGRAMS + '_FETCH_COMPLETED';

export {
  PROGRAMS_FETCH_COMPLETED, PROGRAMS_FETCH_STARTED
};
